<template>
  <!-- Course Section 04 -->
  <div class="course_list">
    <section class>
      <div class="container">
        <div class="container">
          <div class="">
            <div class="hero-textn course_body_list">
              <h2>{{ $root.Courses.text }}</h2>

              <!-- <form
                class="form-inline d-flex justify-content-center md-form form-sm active-purple-2 mt-2"
              >
                <input
                  
                  class="form-control form-control-sm mr-3 w-75"
                  type="text"
                  :placeholder="$root.search.place"
                  aria-label="Search"
                />
                <button>
                  <i class="fas fa-search" aria-hidden="true" style="color:#005A06;"></i>
                </button>
              </form> -->
            </div>
          </div>
        </div>
      </div>
      <div class="hero-image">
        <img src="/assets/exported/new_course.jpg" alt />
      </div>
    </section>
    <section>
      <div class="container course_hero">
        <!-- {{$root.user_profile.token}} -->
        <h2>{{ $root.h_body_r.r_course }}</h2>
        <div class="spinner" v-if="isLoading">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
        <div
          v-for="(modules, d_index) in nutrition"
          :key="d_index"
          :value="modules.id"
          class="course_list_menu course_list_menu_home"
        >
          <img :src="modules.picture_url" alt />
          <div class="row_course">
            <h2>{{ modules.name }}</h2>
            <p>{{ modules.module_count }} {{ $root.module_count.r_modules }}</p>
            <div class="row_course_right offset-xl-1 zoom">
              <a @click="gotoCourse(modules.id)">
                {{ $root.h_body_b.r_button }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  data() {
    return {
      query: "",
      content: [],
      nutrition: [],
      isLoading: true,
      wKey: 0,
      mKey: 1,
      hideSearchBox: true,
    };
  },
  components: {},
  watch: {},
  mounted() {
    this.reloadAPI();
    this.$root.page_hook = this;
  },
  methods: {
    reloadAPI() {
      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (window.localStorage.getItem("getcourse") != null) {
          console.log("Local Data: getcourse");
          var localData = JSON.parse(window.localStorage.getItem("getcourse"));
          this.nutrition = localData;
          return;
        }
      }

      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
        },
      };
      axios
        .get(this.$root.API_BASE_URL + "getcourse", config)
        .then((response) => {
          this.$root.course_list = response.data;
          // Response received From Server
          this.isLoading = false;

          if (response.data == []) {
            // Blank
            return;
          }

          this.nutrition = response.data.data;

          // Save Locally
          localStorage.setItem("getcourse", JSON.stringify(response.data.data));
        });
    },
    gotoCourse(id) {
      if (this.$root.logged_in == true) {
        this.$root.selectCourse(id);
        this.$router.push("/course_description");
      } else {
        this.$router.push("/login");
      }
    },
    // searchFocus() {
    //   //alert(this.$root.hideSearch);
    //   window.scrollTo(0, 0);
    //   this.$root.hideSearch = false;
    //   this.searchQ();
    // },
    reloadRouter() {
      this.mKey = !this.mKey;
      this.wKey = !this.wKey;
    },
  },
  beforeMount() {
    this.$root.syncOnline();
  },
  beforeDestroy() {
    this.$root.page_hook = null;
  },
};
</script>

<style scoped>
.course_body_list h2{
  margin-left: -18px;
}
.course_list {
  margin-bottom: 60px;
  background: #fff;
}
.course_list_menu {
  width: 60%;
}
.course_list .hero-image h2 {
  position: absolute;
}
.course-list_menu p:hover {
  width: 58%;
  box-shadow: 0px 1px 6px #00000085;
  padding: 8px;
  border-radius: 6px;
}
.content-section-01 {
  padding: 20px 0 80px;
}
.course_hero h2 {
  font-size: 28px;
  padding-bottom: 20px;
}
@media screen and (max-width: 3100px) {
  .course_list .form-inline {
    left: 40%;
  }
  .course_list .hero-image h2 {
    left: 45.5%;
  }
}
@media screen and (max-width: 1920px) {
  .course_list .form-inline {
    left: 42%;
  }
  .course_list .hero-image h2 {
    left: 45.5%;
  }
}

@media screen and (max-width: 1440px) {
  .course_list .form-inline {
    left: 38%;
  }
  .course_list .hero-image h2 {
    left: 42.5%;
  }
}
@media screen and (max-width: 1100px) {
  .course_list .form-inline {
    left: 35%;
  }
  .course_list .hero-image h2 {
    left: 40.5%;
  }
}
@media screen and (max-width: 1023px) {
  .course_list .form-inline {
    left: 32%;
  }
  .course_list .hero-image h2 {
    left: 40%;
  }
}
@media screen and (max-width: 990px) {
  .spinner {
    margin: 100px 170px;
    margin-top: 40px;
  }
  .course_list .form-inline {
    left: 30%;
  }
}
@media screen and (max-width: 768px) {
  .course_list_menu {
    width: 80%;
  }
  .course_list .form-inline {
    left: auto;
  }
  .course_list .form-inline {
    left: auto;
  }
}
@media screen and (max-width: 480px) {
  .course_list_menu {
    width: 100%;
  }
  .course_hero h2 {
    font-size: 24px;
    padding-bottom: 20px;
  }
}
</style>
